<card-expanding>
  <span header-title>{{ 'cards.clients.contacts.title' | translate}}</span>
  <div class="contacts-section" body>
    <own-contacts-list [clientId]="clientId"></own-contacts-list>
    <official-contacts-list [clientId]="clientId" *ngIf="showOfficialContacts"></official-contacts-list>
  </div>
</card-expanding>

